import React, { useEffect } from "react";
import LineChart from "../utils/LineChart";
import { useDispatch, useSelector } from "react-redux";
import AreaChart from "../utils/AreaChart";
import { getDashboard, getLakes, getUserError } from "../store/slices/userSlice";
import moment from "moment";
import { dashboard, recentLakes } from "../store/featureActions";
import { Swiper, SwiperSlide } from "swiper/react";
import {
  Autoplay,
  Navigation,
  Pagination,
  Mousewheel,
  Keyboard,
} from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
const Dashboard = () => {
  const dispatch = useDispatch();
  const dashboardData = useSelector(getDashboard);
  const lakes = useSelector(getLakes);
  const error = useSelector(getUserError);
  async function data() {
    try {
      let payload = {
        params: false,
        isToast: false,
      };
      await dispatch(dashboard(payload)).unwrap();
    } catch (rejectedValueOrSerializedError) {
      console.log(rejectedValueOrSerializedError);
    }
  }

  async function lakesData() {
    try {
      let payload = {
        params: false,
        isToast: false,
      };
      await dispatch(recentLakes(payload)).unwrap();
    } catch (rejectedValueOrSerializedError) {
      console.log(rejectedValueOrSerializedError);
    }
  }
  useEffect(() => {
    let mount = true;
    if (mount) {
      data();
      lakesData();
    }
    return () => {
      mount = false;
    };
  }, []);

  const dashData = [
    {
      id: 1,
      name: "Total Users",
      count: dashboardData?.usersCount
    },
    {
      id: 2,
      name: "Total Games",
      count: dashboardData?.gameCount
    },
    {
      id: 3,
      name: "Solo Games",
      count: dashboardData?.soloCount
    },
    {
      id: 4,
      name: "Drop In Games",
      count: dashboardData?.dropInCount
    },
    {
      id: 5,
      name: "One on One Games",
      count: dashboardData?.oneOnOneCount
    },
    {
      id: 6,
      name: "Single Tournament",
      count: dashboardData?.singleCount
    },
    {
      id: 7,
      name: "Team Tournament",
      count: dashboardData?.teamCount
    },
  ];
  return (
    <>
      <div className="main-panel">
        <div className="content-wrapper2">
          <div className="page-header">
            <h3 className="page-title">
              <span className="page-title-icon bg-gradient-primary text-white me-2">
                <i className="mdi mdi-home" />
              </span>{" "}
              Dashboard
            </h3>
          </div>
          <div className="row">


            <Swiper
              cssMode={true}
              navigation={true}
              pagination={true}
              mousewheel={true}
              loop={true}
              keyboard={true}
              slidesPerView={2}
              modules={[Navigation, Pagination, Mousewheel, Keyboard]}
              autoplay={{
                delay: 5000,
                disableOnInteraction: false,
              }}
              breakpoints={{
                767: {
                  slidesPerView: 2,
                },

                480: {
                  slidesPerView: 1,
                },
                375: {
                  slidesPerView: 1,
                },
                300: {
                  slidesPerView: 1,
                },
              }}
            >
              {dashData?.map(search => (
                <SwiperSlide key={search?.id}>
                  <div className="swiper-data">
                    <div className="col-10 col-md-11 stretch-card grid-margin">
                      <div className="card bg-gradient-danger card-img-holder text-white">
                        <div className="card-body">
                          <img src="/assets/images/circle.png" className="card-img-absolute" alt="circle-image" />
                          <h4 className="font-weight-normal mb-3">
                            {search?.name}
                            <i className="mdi mdi-account-outline mdi-24px float-right" />
                          </h4>
                          <h2 className="mb-5">{search?.count}</h2>
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
            {/* <div className="col-md-4 stretch-card grid-margin">
              <div className="card bg-gradient-danger card-img-holder text-white">
                <div className="card-body">
                  <img src="/assets/images/circle.png" className="card-img-absolute" alt="circle-image" />
                  <h4 className="font-weight-normal mb-3">
                    Total Users
                    <i className="mdi mdi-account-outline mdi-24px float-right" />
                  </h4>
                  <h2 className="mb-5">{dashboardData?.usersCount}</h2>
                </div>
              </div>
            </div>
            <div className="col-md-4 stretch-card grid-margin">
              <div className="card bg-gradient-info card-img-holder text-white">
                <div className="card-body">
                  <img src="/assets/images/circle.png" className="card-img-absolute" alt="circle-image" />
                  <h4 className="font-weight-normal mb-3">
                    Total Games
                    <i className="mdi mdi-controller-classic mdi-24px float-right" />
                  </h4>
                  <h2 className="mb-5">{dashboardData?.gameCount}</h2>
                </div>
              </div>
            </div>
            <div className="col-md-4 stretch-card grid-margin">
              <div className="card bg-gradient-danger card-img-holder text-white">
                <div className="card-body">
                  <img src="/assets/images/circle.png" className="card-img-absolute" alt="circle-image" />
                  <h4 className="font-weight-normal mb-3">
                    Solo Games
                    <i className="mdi mdi-controller-classic mdi-24px float-right" />
                  </h4>
                  <h2 className="mb-5">{dashboardData?.soloCount}</h2>
                </div>
              </div>
            </div>
            <div className="col-md-4 stretch-card grid-margin">
              <div className="card bg-gradient-info card-img-holder text-white">
                <div className="card-body">
                  <img src="/assets/images/circle.png" className="card-img-absolute" alt="circle-image" />
                  <h4 className="font-weight-normal mb-3">
                    Drop In Games
                    <i className="mdi mdi-controller-classic mdi-24px float-right" />
                  </h4>
                  <h2 className="mb-5">{dashboardData?.dropInCount}</h2>
                </div>
              </div>
            </div>
            <div className="col-md-4 stretch-card grid-margin">
              <div className="card bg-gradient-danger card-img-holder text-white">
                <div className="card-body">
                  <img src="/assets/images/circle.png" className="card-img-absolute" alt="circle-image" />
                  <h4 className="font-weight-normal mb-3">
                    One on One Games
                    <i className="mdi mdi-controller-classic mdi-24px float-right" />
                  </h4>
                  <h2 className="mb-5">{dashboardData?.oneOnOneCount}</h2>
                </div>
              </div>
            </div>
            <div className="col-md-4 stretch-card grid-margin">
              <div className="card bg-gradient-info card-img-holder text-white">
                <div className="card-body">
                  <img src="/assets/images/circle.png" className="card-img-absolute" alt="circle-image" />
                  <h4 className="font-weight-normal mb-3">
                    Single Tournament
                    <i className="mdi mdi-controller-classic mdi-24px float-right" />
                  </h4>
                  <h2 className="mb-5">{dashboardData?.singleCount}</h2>
                </div>
              </div>
            </div>
            <div className="col-md-4 stretch-card grid-margin">
              <div className="card bg-gradient-danger card-img-holder text-white">
                <div className="card-body">
                  <img src="/assets/images/circle.png" className="card-img-absolute" alt="circle-image" />
                  <h4 className="font-weight-normal mb-3">
                    Team Tournament
                    <i className="mdi mdi-controller-classic mdi-24px float-right" />
                  </h4>
                  <h2 className="mb-5">{dashboardData?.teamCount}</h2>
                </div>
              </div>
            </div> */}










            {/* <div className="col-md-4 stretch-card grid-margin">
              <div className="card bg-gradient-info card-img-holder text-white">
                <div className="card-body">
                  <img src="/assets/images/circle.png" className="card-img-absolute" alt="circle-image" />
                  <h4 className="font-weight-normal mb-3">
                    Total Lakes <i className="mdi mdi-waves mdi-24px float-right" />
                  </h4>
                  <h2 className="mb-5">{dashboardData?.lakeCount}</h2>
                </div>
              </div>
            </div> */}
          </div>
          <div className="row">
            <div className="col-md-6 grid-margin stretch-card">
              <div className="card">
                <div className="card-body">
                  <div className="clearfix">
                    <h4 className="card-title float-left">All Users</h4>
                    <div id="visit-sale-chart-legend" className="rounded-legend legend-horizontal legend-top-right float-right" />
                  </div>
                  <LineChart />
                </div>
              </div>
            </div>
            <div className="col-md-6 grid-margin stretch-card">
              <div className="card">
                <div className="card-body ">
                  <h4 className="card-title">All Games</h4>
                  <AreaChart />
                  <div id="traffic-chart-legend" className="rounded-legend legend-vertical legend-bottom-left pt-4" />
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12 grid-margin">
              <div className="card">
                <div className="card-body">
                  <h4 className="card-title">Recent Lakes</h4>
                  <div className="table-responsive" style={{ textAlign: "center" }}>
                    {lakes?.length > 0 ? (
                      <table className="table">
                        <thead style={{ textAlign: "center" }}>
                          <tr>
                            <th> S.No </th>
                            <th> Lake Name</th>
                            <th> Lake Added</th>
                          </tr>
                        </thead>
                        <tbody style={{ textAlign: "center" }}>
                          {lakes?.map((item, i) => (
                            <tr key={i}>
                              <td>{i + 1}</td>
                              <td style={{ textAlign: "start" }}>{item?.name}</td>
                              <td>
                                <span>{moment(item?.createdAt).format("DD-MMM-YYYY")}</span>
                                <br />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    ) : (
                      <>{error}</>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div></div>
    </>
  );
};

export default Dashboard;
